module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.clientAddress.edit.title')))]), _vm._v(" "), (!_vm.loading) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 24
    }
  }, [(_vm.clientAddresses) ? _c('el-collapse', {
    model: {
      value: (_vm.clientAddressNames),
      callback: function($$v) {
        _vm.clientAddressNames = $$v
      },
      expression: "clientAddressNames"
    }
  }, _vm._l((_vm.clientAddresses), function(address, index) {
    return _c('el-collapse-item', {
      key: address.id,
      attrs: {
        "title": _vm.$t(("form.addressTypes.options." + (_vm.camelize(address.name)))),
        "name": address.name
      }
    }, [_c('v-client-address', {
      attrs: {
        "id": address.id,
        "name": address.name,
        "errors": _vm.getAddressFieldErrors(address.id),
        "data": address,
        "countries": _vm.countries.items,
        "municipalities": _vm.municipalities.items
      },
      on: {
        "update": function($event) {
          _vm.clientAddresses[index] = $event
        }
      }
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-t-10"
  }, [_c('el-button', {
    staticClass: "small dark",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0072a12a","hasScoped":true}!./src/app/components/clientAddressPopup/clientAddressPopup.html
// module id = 2889
// module chunks = 1